import { MtTaskObserver } from "server/models"
import { GET, DELETE, POST } from "client/store/utils"
import { TaskObserverList } from "./types"


export const LoadAllTaskObservers = () => (
    GET("/mtTaskObserver/all")
    .then((rows: MtTaskObserver[]) => {
        const taskObserverList: TaskObserverList = {}
        rows.forEach((row) => {
            const userIds: number[] = taskObserverList[row.taskId] ? taskObserverList[row.taskId].slice() : []
            userIds.push(row.userId)
            taskObserverList[row.taskId] = userIds
        })
        return taskObserverList
    })
)

export const LoadTaskObservers = (taskId: number) => (
    GET(`/mtTaskObserver/taskId/${taskId}`)
    .then((rows: MtTaskObserver[]) => {
        const userIds: number[] = []
        rows.forEach((row) => {
            userIds.push(row.userId)
        })
        return userIds
    })
)

const createObserverList = (userIds: readonly number[], taskId: number) => {
    const observers: MtTaskObserver[] = []
    userIds.forEach((userId) => {
        observers.push({
            taskId,
            userId,
        })
    })
    return observers
}

export const AddTaskObservers = (userIds: readonly number[], taskId: number) => {
    const newObservers = createObserverList(userIds, taskId)
    return POST(
        "/mtTaskObserver/add",
        JSON.stringify(newObservers),
    )
}

export const SaveTaskObserverList = (userIds: readonly number[], taskId: number) => {
    const updatedObservers = createObserverList(userIds, taskId)
    return POST(
        "/mtTaskObserver/save",
        JSON.stringify(updatedObservers),
    )
}

export const DeleteTaskObserver = (userId: number, taskId: number) => (
    DELETE(`/mtTaskObserver/delete/${userId}/${taskId}`)
    .then((removedRows: number) => removedRows)
)
